import React, {
  useEffect,
  useState,
  useRef,
  useCallback,
  useMemo,
  useLayoutEffect,
} from "react";
import { useDispatch, useSelector } from "react-redux";
import { DataGrid } from "@mui/x-data-grid";
import isEqual from "react-fast-compare";
import { CaretUpOutlined, EnvironmentOutlined } from "@ant-design/icons";
import { Tooltip } from "@mui/material";
import { setGridConfig } from "../../../redux/actions/WidgetMaker/GraphConfig";
import { SocialMedialogo } from "../../layout/DeepDive/DeepDivetab/SocialMediaPlatforms";
import { getCountryLogo, getGenderLogo } from "../../utils/Logos";
import defaultImage from "../../../assets/brandLogos/Default_Brand.svg";
import googleVerified from "../../../assets/VerifiedIcons/google-verified.svg";
import googleUnverified from "../../../assets/VerifiedIcons/google-unverified.svg";
import {
  callNotification,
  deepCopy,
  getAllDeepDiveDashboardFilters,
  getAllFilters,
  getAllShareFilters,
  getBrands,
  getCustomizedDate,
  getPaneIndex,
  getWindowLocationPath,
  useQuery,
} from "../../../redux/constants";

import { getColumns, getDataSource } from "./advGridUtils/AdvGridUtils";

import {
  setScreenIsDeepDive,
  setScreenIsDeepDiveDashboard,
  setSelectedDeepdiveWidgetInScreen,
} from "../../../redux/actions/commandCenter/screens/screen";
import {
  setisDeepDive,
  setIsDeepDiveDashboard,
  setSelectedDeepdiveWidget,
} from "../../../redux/actions/dashboard/Tab1";
import {
  setInitialDeepDiveDashboardData,
  setIsDeepDiveInDashboardTemplateData,
} from "../../../redux/actions/DeepDiveDashboard/DeepDiveDashboard";
import moment from "moment";
import { getAllWidgetScreenFilters } from "../../../redux/constants/commandCenterConstants";
import { setShareSelectedDeepdiveWidget } from "../../../redux/actions/share/Share";
import {
  setDeepDiveInfoLoader,
  setIsDetailedInsightVisible,
  setMentionPageData,
  setTabClick,
} from "../../../redux/actions/DeepDive";
import {
  set_WM_DeepDive,
  setDeepDiveInfluencersObject,
  setDeepDiveMentionsObject,
  setDeepDiveObject,
} from "../../../redux/actions/WidgetMaker/WidgetMaker";
import { getDeepDive } from "../../../redux/actions/WidgetMaker/WidgetAPI";
import { setOptionHighChart } from "../../../redux/actions/HighChart";

import "./AdvGridStyle/gridStyle.css";
import CustomPagination from "./CustomPagination";

function AdvGrid(props) {
  const {
    tableColumns,
    dataSource,
    colors,
    rowSpanOn,
    metadata,
    deepDive,
    section_index,
    widget_index,
    PdfDownloadStatus,
    preview,
    type,
    dashboard,
    hideColumns,
    isdownload,
    isPPTModalOpen,
  } = props;
  const dispatch = useDispatch();
  const preventReRender = useRef(true);
  const resizeDebounce = useRef(null);
  const gridRef = useRef();

  const [loading, setLoading] = React.useState(true);
  const [columns, setColumns] = useState([]);
  const [columnStyle, setColumnStyle] = useState({});
  const [modiFiedColumns, setModifiedColumns] = useState([]);
  const [columnGroupingModel, setColumnGroupingModel] = useState([]);
  const [columnConfig, setColumnConfig] = useState([]);
  const [rows, setRows] = useState([]);
  const [gridConfigSort, setGridConfigSort] = useState({
    sortModel: [],
  });
  const [gridHeight, setGridHeight] = useState(null);
  const [load, setLoad] = useState(false);
  const [minMax, setMinMax] = useState({});
  const [enabledGridDeepDive, setEnableGridDeepDive] = useState(false);
  const [pagination, setPagination] = useState({
    pagination: false,
    pageSizeOptions: [],
  });

  const [paginationModel, setPaginationModel] = React.useState({
    page: 0,
    pageSize: 10,
  });

  const [handleRowSpanning, setHandleRowSpanning] = useState(false);

  const panes = useSelector((state) => state?.Tab1?.panes);

  let pathName = window.location.pathname?.split("/")?.[1];
  const activeKey = useSelector((state) => state?.Tab1?.activeKey);

  let index = getPaneIndex(panes, activeKey);
  const widgetGraphConfig = useSelector(
    (state) => state?.GraphConfig?.widgetGraphConfig
  );

  const graphConditions = useSelector(
    (state) => state?.apiCall?.graphConditions
  );

  const deepdive_object = useSelector(
    (state) => state?.WidgetMaker?.deepdive_object
  );

  const shareTemplateData = useSelector(
    (state) => state?.ApiCall?.shareTemplateData
  );

  const personalizationSettingsObj = useSelector(
    (state) => state?.PersonalizationSetting
  );

  const isScheduleReportOpen = useSelector(
    (state) => state?.ApiCall?.is_schedule_report_open
  );
  const workspace_privileges = useSelector(
    (state) => state.ApiCall.workspace_privileges
  );
  const share_workspace_privileges = useSelector(
    (state) => state.ApiCall.share_workspace_privileges
  );

  const sharedDuration = useSelector((state) => state.Share.sharedDuration);

  const authParams = useSelector((state) => state.Authentication.authParams);

  const screen = useSelector((state) => state?.Screens?.screen);

  const shareBrands = useSelector((state) => state.ApiCall.shareBrands);

  const deepdiveDashboardTemplateData = useSelector(
    (state) => state?.DeepDiveDashboard?.dashboardTemplateData
  );

  const deepdiveDashboardData = useSelector(
    (state) => state?.DeepDiveDashboard?.dashboardData
  );

  const brandlogicalgroup = useSelector(
    (state) => state.ApiCall.brandlogicalgroup?.data?.result
  );

  const brands = useSelector(
    (state) => state.ApiCall.brands?.data?.result?.brands
  );

  const shareCategory = useSelector((state) => state.ApiCall.shareCategory);

  let query = useQuery();

  // Visual Enhancement Helper Functions
  const parseSpecialString = (value) => {
    if (typeof value !== "string") return null;

    if (value.includes("|$|")) {
      const [channelImage, profileName] = value
        .split("|$|")
        .map((s) => s.trim());
      return { type: "social", channelImage, profileName };
    }
    if (value.includes("|G|")) {
      const [, genderName] = value.split("|G|").map((s) => s.trim());
      return { type: "gender", genderName };
    }
    if (value.includes("|C|")) {
      const [, countryName] = value.split("|C|").map((s) => s.trim());
      return { type: "country", countryName };
    }
    return null;
  };

  const renderSpecialContent = (parsedData) => {
    if (!parsedData) return null;

    switch (parsedData.type) {
      case "social":
        return (
          <div style={{ display: "flex", alignItems: "center" }}>
            <img
              style={{ width: "1.5rem", height: "1.5rem", margin: "0.5rem" }}
              src={SocialMedialogo?.[parsedData.channelImage] || defaultImage}
              alt={parsedData.channelImage}
            />
            <span className="socialText">{parsedData.profileName}</span>
          </div>
        );
      case "gender":
        return (
          <div style={{ display: "flex", alignItems: "center" }}>
            <img
              style={{ width: "1.5rem", height: "1.5rem", margin: "0.5rem" }}
              src={getGenderLogo(parsedData.genderName)}
              alt={parsedData.genderName}
            />
            <span className="socialText">{parsedData.genderName}</span>
          </div>
        );
      case "country":
        return (
          <div style={{ display: "flex", alignItems: "center" }}>
            {getCountryLogo(parsedData.countryName)}
            <span className="socialText">{parsedData.countryName}</span>
          </div>
        );
      default:
        return null;
    }
  };

  const renderRating = (value) => {
    if (
      typeof value === "string" &&
      (value.includes("Review Ratings") || value.includes("Rating"))
    ) {
      return value !== "NA" ? `${value} ⭐` : value;
    }
    return value;
  };

  const renderGMBLocation = (value, rowData) => {
    if (value && value !== "NA") {
      return (
        <Tooltip
          slotProps={{
            tooltip: {
              sx: {
                bgcolor: "#2d3e5c", // background color
                color: "#fff", // text color
                fontSize: "14px", // font size
                padding: "8px 12px", // padding inside tooltip
                borderRadius: "8px", // rounded corners
                boxShadow: 3, // elevation
              },
            },
          }}
          title={value}
        >
          <a
            href={value}
            target="_blank"
            rel="noopener noreferrer"
            onClick={(e) => e.stopPropagation()}
            style={{ color: "#1890ff" }}
          >
            <EnvironmentOutlined style={{ fontSize: "18px" }} />
          </a>
        </Tooltip>
      );
    }
    return (
      <EnvironmentOutlined
        style={{ fontSize: "18px", color: "#ccc", cursor: "default" }}
      />
    );
  };
  // Enhanced data transformation function with chart cards support
  const getUpdatedDataSource = (sources) => {
    let updatedDataSource =
      sources && Array.isArray(sources)
        ? JSON.parse(JSON.stringify(sources))
        : [];

    if (props?.grand_total && updatedDataSource?.length) {
      updatedDataSource[updatedDataSource?.length - 1].total_flag = true;
    }

    if (updatedDataSource?.length) {
      updatedDataSource =
        sources &&
        sources.map((el, i) => {
          let columnNames = Object.keys(el);

          if (props?.tree_grid) {
            if (columnNames?.length > 0) {
              let updatedEl = { ...el };
              columnNames?.forEach((c, index) => {
                let rowData = updatedEl?.[c];

                // Handle GMB URL columns
                if (
                  tableColumns?.[index]?.attribute === "gmb_url" &&
                  (props?.metadata?.chart_type === "grid" ||
                    props?.metadata?.chart?.chart_type === "grid")
                ) {
                  updatedEl[c] = rowData; // Keep original value for SmartGrid to handle in renderCell
                }
                // Handle object_profile_name with GMB URL and Verified icons
                else if (
                  (props?.metadata?.chart_type === "grid" ||
                    props?.metadata?.chart?.chart_type === "grid") &&
                  ["object_profile_name", "emailcontenthtml"]?.includes(
                    tableColumns?.[index]?.attribute ||
                      tableColumns?.[index]?.column_details?.attribute
                  )
                ) {
                  updatedEl[c] = rowData; // Keep original value for SmartGrid to handle in renderCell
                }
                // Handle special string formats
                else if (
                  typeof rowData === "string" &&
                  (rowData?.includes("|$|") ||
                    rowData?.includes("|G|") ||
                    rowData?.includes("|C|"))
                ) {
                  updatedEl[c] = rowData; // Keep original value for SmartGrid to handle in renderCell
                }
                // Handle rating columns
                else if (c?.includes("Review Ratings")) {
                  updatedEl[c] =
                    updatedEl[c] !== "NA" ? `${updatedEl[c]} ⭐` : updatedEl[c];
                } else if (c?.includes("Rating")) {
                  updatedEl[c] =
                    updatedEl[c] !== "NA" ? `${updatedEl[c]} ⭐` : updatedEl[c];
                }
              });
              return updatedEl;
            } else {
              return el;
            }
          } else if (columnNames?.includes("Review Ratings")) {
            return {
              ...el,
              [`Review Ratings`]:
                el[`Review Ratings`] !== "NA"
                  ? `${el[`Review Ratings`]} ⭐`
                  : el[`Review Ratings`],
            };
          } else if (columnNames?.includes("Rating")) {
            return {
              ...el,
              [`Rating`]:
                el[`Rating`] !== "NA" ? `${el[`Rating`]} ⭐` : el[`Rating`],
            };
          } else {
            return el;
          }
        });

      // PDF download optimization
      if (props?.PdfDownloadStatus) {
        if (
          props?.templateId === "000-000-242" &&
          updatedDataSource?.length > 7
        ) {
          updatedDataSource = updatedDataSource?.slice(0, 7);
        } else if (
          props?.noteExist &&
          props?.insightsExist &&
          updatedDataSource?.length > 8
        ) {
          updatedDataSource = updatedDataSource?.slice(0, 8);
        } else if (updatedDataSource?.length > 9 && props?.pdfView) {
          updatedDataSource = updatedDataSource?.slice(0, 9);
        } else if (updatedDataSource?.length > 11) {
          updatedDataSource = updatedDataSource?.slice(0, 11);
        }
      }
    }
    return updatedDataSource;
  };
  // deep dive status
  const shareableLinkDeepDiveStatus = useSelector(
    (state) => state.ApiCall.shareableLinkDeepDiveStatus
  );

  useLayoutEffect(() => {
    if (
      props?.gridConfig &&
      Object.keys(props?.gridConfig).length > 0 &&
      preventReRender.current
    ) {
      props?.gridConfig?.sortModel &&
        setGridConfigSort({ sortModel: [...props?.gridConfig?.sortModel] });
      props?.gridConfig?.columnConfig &&
        setColumnConfig(props?.gridConfig?.columnConfig);
      props?.gridConfig?.columnStyle &&
        setColumnStyle(props?.gridConfig?.columnStyle);
      preventReRender.current = false;
    }
    setLoading(false);
  }, [props]);

  const setPaginationConfig = (rowLength) => {
    if (rowLength < 11) {
      setPagination({
        pagination: true,
        pageSizeOptions: [],
      });
    } else if (rowLength >= 11 && rowLength < 21) {
      setPagination({
        pagination: false,
        pageSizeOptions: [10, 20],
      });
    } else if (rowLength >= 21 && rowLength < 41) {
      setPagination({
        pagination: false,
        pageSizeOptions: [10, 20],
      });
    } else if (rowLength >= 41 && rowLength < 61) {
      setPagination({
        pagination: false,
        pageSizeOptions: [10, 20, 30],
      });
    } else if (rowLength >= 61 && rowLength < 81) {
      setPagination({
        pagination: false,
        pageSizeOptions: [10, 20, 30, 40],
      });
    } else if ((rowLength >= 81 && rowLength < 101) || rowLength >= 100) {
      setPagination({
        pagination: false,
        pageSizeOptions: [10, 20, 30, 40, 50],
      });
    }
  };

  useEffect(() => {
    const { columns, nestedParentColumn } = getColumns(
      tableColumns,
      columnConfig,
      columnStyle,
      props?.preview,
      rowSpanOn,
      type,
      hideColumns,
      props?.metadata?.type,
      isdownload,
      isPPTModalOpen,
      dataSource[0]
    );
    if (nestedParentColumn.length) {
      setColumnGroupingModel(nestedParentColumn);
    }
    const rows = getDataSource(getUpdatedDataSource(dataSource));
    setColumns(columns);
    setRows(rows);
    setPaginationConfig(rows?.length);
    if (rowSpanOn && columnConfig?.length > 0) {
      for (let col of columnConfig) {
        if (col?.title === rowSpanOn) {
          if (col?.visible) {
            setHandleRowSpanning(true);
          } else {
            setHandleRowSpanning(false);
          }
        }
      }
    } else if (rowSpanOn) {
      if (rowSpanOn) {
        setHandleRowSpanning(true);
      } else if (!rowSpanOn) {
        setHandleRowSpanning(false);
      }
    }
  }, [props, columnConfig, columnStyle, tableColumns, dataSource]);

  useEffect(() => {
    if (
      JSON.stringify(columnConfig) !==
        JSON.stringify(props?.gridConfig?.columnConfig) &&
      props.gridConfig?.columnConfig
    ) {
      setColumnConfig(props?.gridConfig?.columnConfig);
    }
  }, [props]);

  useEffect(() => {
    if (!rows.length) return;
    if (
      widgetGraphConfig?.chart_settings?.show_valley ||
      widgetGraphConfig?.chart_settings?.show_peak
    ) {
      // Find min max for number column
      const result = {};
      rows.forEach((obj) => {
        Object.entries(obj).forEach(([key, value]) => {
          if (typeof value === "number") {
            if (!result[key]) {
              result[key] = {
                min: value,
                max: value,
                secondMax: Number.NEGATIVE_INFINITY, // Initialize secondMax,
              };
            } else {
              // Update min
              result[key].min = Math.min(result[key].min, value);

              // Update max and secondMax
              if (value > result[key].max) {
                // Shift old max to secondMax
                result[key].secondMax = result[key].max;
                result[key].max = value;
              } else if (
                value < result[key].max &&
                value > result[key].secondMax
              ) {
                // Update only if between secondMax and max
                result[key].secondMax = value;
              }
            }
          }
        });
      });

      if (
        props?.metadata?.chart?.chart_settings?.total_row ||
        props?.metadata?.chart_settings?.total_row
      ) {
        Object.keys(result).forEach((key) => {
          result[key].max = result[key].secondMax;
        });
      }

      rows.forEach((obj) => {
        Object.entries(obj).forEach(([key, value]) => {
          if (result[key] && result[key].min === value) {
            result[key].minId = obj.id;
          }

          if (result[key] && result[key].max === value) {
            result[key].maxId = obj.id;
          }
        });
      });
      setMinMax(result);
    }
  }, [rows, widgetGraphConfig]);

  useEffect(() => {
    const calculateHeightDynamically = async () => {
      await new Promise((resolve) => setTimeout(resolve, 0)); // 0ms delay
      const gridElement = gridRef.current?.querySelector(
        ".MuiDataGrid-virtualScrollerContent"
      );
      const showPreviousDuration =
        props?.metadata?.chart?.chart_settings?.show_previous_duration_data ||
        props?.metadata?.chart_settings?.show_previous_duration_data;

      if (gridElement) {
        // Get first 20 row elements
        const rowEls = Array.from(
          gridElement.querySelectorAll(".MuiDataGrid-row")
        ).slice(0, 20);
        if (rowEls?.length > 0 && paginationModel?.pageSize >= 20) {
          if (rowEls.length < 11) {
            setGridHeight(null);
            return;
          }
          if (gridHeight) {
            return;
          }
          let heights = rowEls.map((ele) => ele?.offsetHeight);
          let maxHeight = Math.max(...heights);
          let totalHeight = maxHeight * Math.min(rowEls.length + 1, 10) + 70;
          if (showPreviousDuration) {
            totalHeight += 80; // Add extra height for comparison row
          }
          setGridHeight(totalHeight);
        } else {
          setGridHeight(null);
        }
      }
    };

    calculateHeightDynamically();
  }, [rows, paginationModel, props]);

  useEffect(() => {
    const sort = props?.gridConfig?.sortModel;
    if (
      gridConfigSort &&
      JSON.stringify(sort) !== JSON.stringify(gridConfigSort.sortModel) &&
      type === "grid" &&
      !dashboard
    ) {
      dispatch(
        setGridConfig({
          ...props?.gridConfig,
          sortModel: gridConfigSort.sortModel,
        })
      );
    }
  }, [gridConfigSort, props]);

  useEffect(() => {
    const columnStyleProp = props?.gridConfig?.columnStyle;
    if (
      columnStyle &&
      JSON.stringify(columnStyleProp) !== JSON.stringify(columnStyle) &&
      type === "grid" &&
      !dashboard
    ) {
      dispatch(
        setGridConfig({ ...props?.gridConfig, columnStyle: columnStyle })
      );
    }
  }, [columnStyle, props]);

  useEffect(() => {
    if (isdownload || isPPTModalOpen) {
      setPagination({
        pagination: true,
        pageSizeOptions: [],
      });
    }
  }, [isdownload, isPPTModalOpen]);

  const enableGridDeepDive = useMemo(() => {
    if (
      (pathName === "dashboard" || pathName === "pin-dashboard") &&
      Array.isArray(metadata?.chart?.chart_settings?.user_deepdive_columns) &&
      metadata.chart.chart_settings.user_deepdive_columns.length > 0
    ) {
      let columnName =
        metadata?.chart?.chart_settings?.user_deepdive_columns?.[0];

      if (columns?.[0]?.title === columnName) {
        return true;
      }
    } else if (
      (pathName !== "dashboard" || pathName !== "pin-dashboard") &&
      metadata?.chart?.chart_type === "grid" &&
      Array.isArray(metadata?.chart?.chart_settings?.user_deepdive_columns) &&
      metadata.chart.chart_settings.user_deepdive_columns.length > 0
    ) {
      return shareableLinkDeepDiveStatus;
    }
    return false;
  }, [metadata, columns, pathName, shareableLinkDeepDiveStatus]);

  const allowedDeepDive = useMemo(() => {
    return authParams?.screen_id ||
      (shareBrands && shareableLinkDeepDiveStatus) ||
      ((pathName === "dashboard" || pathName === "pin-dashboard") &&
        !panes[getPaneIndex(panes, activeKey)]?.is_widget_maker_open_obj
          ?.open_flag)
      ? !deepdiveDashboardTemplateData?.isDeepDive &&
        !isScheduleReportOpen &&
        !preview
        ? true
        : false
      : false;
  }, [
    shareableLinkDeepDiveStatus,
    authParams,
    isScheduleReportOpen,
    shareBrands,
    pathName,
  ]);

  const isDeepDiveEnabledForThisColumn = useCallback(
    (index, deep_dive_info) => {
      return index === 0 && enabledGridDeepDive && !PdfDownloadStatus
        ? true
        : allowedDeepDive &&
          deep_dive_info?.template_id &&
          Array.isArray(deep_dive_info?.template_id) &&
          deep_dive_info?.template_id?.length > 0
        ? true
        : false;
    },
    [enableGridDeepDive]
  );

  const isDeepDiveOpened = authParams?.screen_id
    ? screen?.isDeepDive
    : shareableLinkDeepDiveStatus
    ? shareTemplateData?.isDeepDive
    : (!authParams?.screen_id &&
        !shareBrands &&
        panes[getPaneIndex(panes, activeKey)].isDeepDive) ||
      deepDive;

  const isDeepDiveDashboardView = useMemo(() => {
    let pathName = getWindowLocationPath()?.toLowerCase();
    return (
      (authParams?.screen_id
        ? screen?.isDeepDiveDashboard
          ? true
          : false
        : shareableLinkDeepDiveStatus
        ? shareTemplateData?.isDeepDiveDashboard
          ? true
          : false
        : !authParams?.screen_id &&
          !shareBrands &&
          (pathName === "dashboard" || pathName === "pin-dashboard") &&
          !panes?.[getPaneIndex(panes, activeKey)]?.is_widget_maker_open_obj
            ?.open_flag &&
          panes?.[getPaneIndex(panes, activeKey)]?.isDeepDiveDashboard
        ? true
        : false) && !deepdiveDashboardTemplateData?.isDeepDive
    );
  }, [
    screen,
    shareTemplateData,
    panes,
    authParams,
    deepdiveDashboardTemplateData,
  ]);

  useEffect(() => {
    setEnableGridDeepDive(enableGridDeepDive);
  }, [enableGridDeepDive]);

  function handleColumnResize(params) {
    clearTimeout(resizeDebounce?.current);
    resizeDebounce.current = setTimeout(() => {
      if (!params?.colDef?.field) return;
      setColumnStyle((pre) => {
        return {
          ...pre,
          [params?.colDef?.field]: {
            ...pre[params?.colDef?.field],
            width:
              Math.abs(params?.width) >= 500 ? 500 : Math.abs(params?.width),
          },
        };
      });
    }, 300);
  }

  // Deep dive
  function handleGridDeepdive(rowObject, columnObject) {
    let pathName = getWindowLocationPath()?.toLowerCase();
    if (
      (pathName !== "CommandCenter"?.toLowerCase() &&
        !authParams?.screen_id &&
        !shareBrands &&
        graphConditions?.template_calender_action_controls?.includes(
          panes?.[index]?.template_id
        )) ||
      (shareBrands &&
        graphConditions?.template_calender_action_controls?.includes(
          shareTemplateData?.template_id
        ))
    ) {
      callNotification("Deep dive on this dashboard is not available", "error");
      return;
    }
    // adding restriction for deepdive in personalize preview window
    if (personalizationSettingsObj?.isPersonalizationPreviewOpen) {
      callNotification(
        "Actions are not allowed while customizing",
        "info",
        40,
        "personalization-preview-notification personalization-preview-mask",
        true
      );
      return;
    }
    if (isDeepDiveOpened && deepdive_object && !isDeepDiveDashboardView) {
      let deepDiveInfo = columnObject?.column_details?.deep_dive_info;
      if (
        deepDiveInfo?.template_id &&
        Array.isArray(deepDiveInfo?.template_id)
      ) {
        let graphObject = {
          account_list: deepdive_object?.account_list,
          start_date: deepdive_object?.start_date,
          end_date: deepdive_object?.end_date,
          brands: deepdive_object?.brands,
          filters: deepdive_object?.filters ? deepdive_object?.filters : null,
          shareCategory: deepdive_object?.shareCategory,
          filter_by: deepdive_object?.filter_by,
          filter_dropdown: deepdive_object?.filter_dropdown,
          isTicketBased: deepdive_object?.isTicketBased || false,
          isWorkFlowBased: deepdive_object?.isWorkFlowBased || false,
          isSurveyCardBased: deepdive_object?.isSurveyCardBased || false,
          public_engagement_only:
            deepdive_object?.public_engagement_only || false,
          isBrandModified: deepdive_object?.isBrandModified || false,
        };
        // don't need here selected widget information

        let templateId = deepDiveInfo?.template_id?.[0];
        graphObject.deepdive_on = {
          x_axis: {
            attribute: columnObject?.column_details?.attribute,
            value: rowObject[columnObject?.title],
            trace_name: columnObject?.title || columnObject?.trace_name,
          },
          y_series: metadata?.y_series ? metadata?.y_series : null,
          y_axis: metadata?.y_axes ? metadata?.y_axes : null,
        };
        graphObject.template_id = templateId;
        // if this is second level deepdive so need to pass sub_deep_dive_on key
        // where old deepdive_on object will pass and new one is same as

        if (deepdive_object?.deepdive_on) {
          let newDeepDiveOnObject = graphObject?.deepdive_on;

          let mentionDeepDiveOnObject = deepdive_object?.deepdive_on
            ? { ...deepdive_object?.deepdive_on }
            : null;
          mentionDeepDiveOnObject = mentionDeepDiveOnObject
            ? deepCopy(mentionDeepDiveOnObject)
            : null;

          let sub_deep_dive_on = [];
          if (
            deepdive_object?.sub_deep_dive_on &&
            Array.isArray(deepdive_object.sub_deep_dive_on)
          ) {
            sub_deep_dive_on = [
              ...sub_deep_dive_on,
              ...deepdive_object.sub_deep_dive_on,
            ];
          }
          if (mentionDeepDiveOnObject) {
            sub_deep_dive_on.push(mentionDeepDiveOnObject);
          }
          graphObject.sub_deep_dive_on =
            sub_deep_dive_on &&
            Array.isArray(sub_deep_dive_on) &&
            sub_deep_dive_on?.length > 0
              ? [...sub_deep_dive_on]
              : null;
        }

        // If brands are by default share brand then need to pass here global brands as dashboard format
        // recalculate
        if (shareBrands) {
          if (
            graphObject?.brands &&
            (graphObject?.brands?.selected_brand_ids?.length > 0 ||
              graphObject?.brands?.selected_brand_groups?.length > 0)
          ) {
            if (graphObject?.brands?.brands?.columns?.length > 0) {
              graphObject.brands = graphObject?.brands?.brands;
            } else if (
              (graphObject?.brands?.selected_brand_ids?.length > 0 ||
                graphObject?.brands?.selected_brand_groups?.length > 0) &&
              !(
                graphObject?.brands?.selected_comp_brand_ids &&
                graphObject?.brands?.selected_comp_brand_ids?.length
              )
            ) {
              // to calculate normal single brand and brand groups
              let selectedBrands = getBrands(
                shareBrands?.brand_groups,
                graphObject?.brands?.selected_brand_ids,
                shareBrands?.brand_list,
                graphObject?.brands?.selected_brand_groups
              );
              graphObject.brands = selectedBrands;
            } else if (
              graphObject?.brands?.selected_brand_ids?.length > 0 &&
              graphObject?.brands?.selected_comp_brand_ids &&
              graphObject?.brands?.selected_comp_brand_ids?.length
            ) {
              let parentB = graphObject?.brands?.selected_brand_ids?.[0];

              let selectedCompBrand = {
                attribute: "BrandID",
                type: "varchar",
                columns: [
                  {
                    group: false,
                    name: parentB?.brand_id,
                    brand_name: parentB?.brand_name,
                    brand_friendly_name: parentB?.brand_friendly_name,
                    type: "include",
                    brand_group_name: false,
                    competitor: true,
                    competitorList:
                      graphObject?.brands?.selected_comp_brand_ids,
                  },
                ],
              };
              graphObject.brands = selectedCompBrand;
            }
          }
        }
        if (pathName === "CommandCenter"?.toLowerCase()) {
          // For Command Center, we need to set the deep dive object
          // Enable Deep Dive Modal
          dispatch(setScreenIsDeepDiveDashboard(true));
        } else if (shareBrands) {
          // For Share Dashboard, we need to set the deep dive object
          shareTemplateData &&
            dispatch({
              type: "SET_SHARE_TEMPLATE_DATA",
              payload: {
                ...shareTemplateData,
                isDeepDiveDashboard: true,
              },
            });
        } else {
          dispatch(setIsDeepDiveDashboard(true, index));
        }
        dispatch(setInitialDeepDiveDashboardData(graphObject));
      }
      return;
    }
    let dashboardDataOfDeepDive = deepdiveDashboardData;
    let deepdiveTemplatData = deepdiveDashboardTemplateData;
    let sectionData = isDeepDiveDashboardView
      ? deepdiveTemplatData?.sections?.[section_index]
      : null;

    let shareSections = shareTemplateData?.section
      ? shareTemplateData?.section?.[0]
      : shareTemplateData?.sections?.[section_index];

    let widget_metadata = isDeepDiveDashboardView
      ? sectionData?.widgets?.[widget_index]
      : pathName === "CommandCenter"?.toLowerCase()
      ? section_index !== null &&
        section_index !== undefined &&
        section_index >= 0 &&
        screen?.sections &&
        screen?.sections?.[section_index]?.widgets?.[widget_index]
        ? screen?.sections?.[section_index]?.widgets?.[widget_index]
        : screen?.section && screen?.section?.[0]?.widgets?.[widget_index]
        ? screen?.section?.[0]?.widgets?.[widget_index]
        : screen?.widgets && screen?.widgets?.[widget_index]
        ? screen?.widgets?.[widget_index]
        : null
      : shareBrands
      ? shareSections?.widgets?.[widget_index]
      : section_index >= 0
      ? panes?.[index]?.sections?.[section_index]?.widgets?.[widget_index]
      : panes?.[index]?.section?.[0]?.widgets?.[widget_index];

    // Checking if `widget_metadata` exists — if so, use it; otherwise, fallback to `metadata`.
    // Slight confusion: if other values are being calculated based on `widget_metadata`,
    // why is `metadata` being used directly in some cases?
    // To ensure consistency, always compare both `widget_metadata` and `metadata` before proceeding.
    widget_metadata = widget_metadata
      ? widget_metadata
      : metadata
      ? metadata
      : null;
    if (
      widget_metadata?.chart?.chart_settings?.allow_deepdive !== false &&
      (widget_metadata?.type !== "predefined" ||
        (authParams?.screen_id &&
          widget_metadata?.chart?.chart_settings?.allow_deepdive)) &&
      !graphConditions?.common
        ?.map((d) => d?.attribute)
        ?.includes(widget_metadata?.y_series?.[0]?.attribute)
    ) {
      // Deep Dive Info calculation process
      let widget_ids = widget_metadata?.deep_dive_id
        ? [widget_metadata?.deep_dive_id]
        : null;
      let section_metadata = isDeepDiveDashboardView
        ? sectionData
        : pathName === "CommandCenter"?.toLowerCase()
        ? section_index !== null &&
          section_index !== undefined &&
          screen?.sections &&
          screen?.sections?.[section_index]
          ? screen?.sections?.[section_index]
          : section_index >= 0 &&
            screen?.sections &&
            screen?.sections?.[section_index]
          ? screen?.sections?.[section_index]
          : screen?.section && screen?.section?.[0]
          ? screen?.section?.[0]
          : null
        : shareBrands
        ? shareSections
        : section_index >= 0
        ? panes?.[index]?.sections?.[section_index]
        : panes?.[index]?.section?.[0];
      let Section_is_locked = section_metadata?.is_locked;
      let widgets_is_locked = widget_metadata?.is_locked;
      let twoMonthsDuration = getCustomizedDate(6, "Days");
      let defaultDuration = {
        from:
          moment(twoMonthsDuration?.date[0]).format("YYYY/MM/DD") +
          " " +
          twoMonthsDuration?.time?.startTime,
        to:
          moment(twoMonthsDuration?.date[1]).format("YYYY/MM/DD") +
          " " +
          twoMonthsDuration?.time?.endTime,
      };
      let global_duration = isDeepDiveDashboardView
        ? dashboardDataOfDeepDive?.start_date
          ? {
              from: dashboardDataOfDeepDive?.start_date,
              to: dashboardDataOfDeepDive?.end_date,
            }
          : null
        : pathName === "CommandCenter"?.toLowerCase()
        ? screen?.duration
        : shareBrands
        ? sharedDuration?.from
          ? {
              from: sharedDuration?.from,
              to: sharedDuration?.to,
            }
          : null
        : panes?.[index]?.duration;
      let global_brands = isDeepDiveDashboardView
        ? dashboardDataOfDeepDive?.brands
        : pathName === "CommandCenter"?.toLowerCase()
        ? screen?.brands
        : shareBrands
        ? shareBrands
        : panes?.[index]?.brands;
      let brandIds =
        shareBrands ||
        pathName === "CommandCenter"?.toLowerCase() ||
        isDeepDiveDashboardView
          ? widget_metadata?.brand_ids
          : section_index >= 0
          ? panes?.[index]?.sections?.[section_index]?.widgets?.[widget_index]
              ?.brand_ids
          : panes?.[index]?.section?.[0]?.widgets?.[widget_index]?.brand_ids
          ? panes?.[index]?.section?.[0]?.widgets?.[widget_index]?.brand_ids
          : null;

      //share link filter code
      let sectionDateFilter = shareTemplateData?.sections
        ? {
            from: shareTemplateData?.sections[section_index]?.start_date
              ? shareTemplateData?.sections[section_index]?.start_date
              : null,
            to: shareTemplateData?.sections[section_index]?.end_date
              ? shareTemplateData?.sections[section_index]?.end_date
              : null,
          }
        : null;

      let widgetFilterDate = {
        from: widget_metadata?.start_date ? widget_metadata?.start_date : null,
        to: widget_metadata?.end_date ? widget_metadata?.end_date : null,
      };

      let combinedFilters = [];
      if (!widget_metadata?.is_locked) {
        if (widgetFilterDate?.from)
          combinedFilters.push({
            attribute: "CreatedDate",
            type: "datetime",
            columns: widgetFilterDate,
          });

        if (sectionDateFilter?.from && !section_metadata?.is_locked) {
          combinedFilters.push({
            attribute: "CreatedDate",
            type: "datetime",
            columns: sectionDateFilter,
          });
        }
        if (section_metadata?.brand_ids && !section_metadata?.is_locked) {
          let brandsForFilter = shareBrands
            ? getBrands(
                shareBrands?.brand_groups,
                section_metadata?.brand_ids,
                shareBrands?.brand_list,
                section_metadata?.brand_groups
              )
            : getBrands(
                brandlogicalgroup,
                section_metadata?.brand_ids,
                brands,
                section_metadata?.brand_groups
              );

          combinedFilters.push(brandsForFilter);
        }
        if (widget_metadata?.brand_ids) {
          let brandsForFilter = shareBrands
            ? getBrands(
                shareBrands?.brand_groups,
                widget_metadata?.brand_ids,
                shareBrands?.brand_list,
                widget_metadata?.brand_groups
              )
            : getBrands(
                brandlogicalgroup,
                widget_metadata?.brand_ids,
                brands,
                widget_metadata?.brand_groups
              );

          combinedFilters.push(brandsForFilter);
        }
      }

      if (widget_metadata?.filters)
        combinedFilters = [...widget_metadata?.filters, ...combinedFilters];
      if (section_metadata?.filters)
        combinedFilters = [...section_metadata?.filters, ...combinedFilters];
      let filterData = combinedFilters?.filter((d) => d);
      let hidden_filter = shareTemplateData?.hidden_filter
        ? [shareTemplateData?.hidden_filter]
        : [];
      let quick_filter = shareTemplateData?.quick_filter
        ? [shareTemplateData?.quick_filter]
        : [];
      let widgetObj = {
        brand_groups: widget_metadata?.brand_groups,
        singleBrands: brands,
      };
      let brandsContainter = {
        brand_ids: widget_metadata?.brand_ids,
        brand_groups: widget_metadata?.brand_groups,
        singleBrands: shareBrands ? shareBrands?.brand_list : brands,
        brandGroupList: shareBrands
          ? shareBrands?.brand_groups
          : brandlogicalgroup,
      };

      let filter = isDeepDiveDashboardView
        ? getAllDeepDiveDashboardFilters(
            graphConditions,
            deepdiveDashboardData,
            deepdiveDashboardTemplateData,
            section_index,
            widget_index,
            brandsContainter
          )
        : pathName === "CommandCenter"?.toLowerCase()
        ? getAllWidgetScreenFilters(
            screen,
            section_index,
            widget_index,
            brands,
            brandlogicalgroup,
            widget_metadata
          )
        : shareBrands
        ? getAllShareFilters(
            graphConditions,
            shareTemplateData,
            section_index,
            widget_index,
            shareBrands
          )
        : getAllFilters(
            graphConditions,
            panes,
            index,
            section_index,
            widget_index,
            brandlogicalgroup,
            brandIds,
            widgetObj
          );

      if (screen?.category_screen_filters?.length) {
        let category_screen_filters = screen?.category_screen_filters?.length
          ? screen?.category_screen_filters
          : [];
        filter = [...filter, ...category_screen_filters];
      }

      let widget_brands = shareBrands
        ? getBrands(
            shareBrands?.brand_groups,
            widget_metadata?.brand_ids,
            shareBrands?.brand_list,
            widget_metadata?.brand_groups
          )
        : getBrands(
            brandlogicalgroup,
            widget_metadata?.brand_ids,
            brands,
            widget_metadata?.brand_groups
          );
      let section_brands = shareBrands
        ? getBrands(
            shareBrands?.brand_groups,
            section_metadata?.brand_ids,
            shareBrands?.brand_list,
            section_metadata?.brand_groups
          )
        : getBrands(
            brandlogicalgroup,
            section_metadata?.brand_ids,
            brands,
            section_metadata?.brand_groups
          );
      let defaultBrands = isDeepDiveDashboardView
        ? dashboardDataOfDeepDive?.brands
        : pathName === "CommandCenter"?.toLowerCase()
        ? brands
        : shareBrands
        ? shareBrands
        : null;
      // This case is applied when we select competition brand and applied competition filter(Owned/Competition)
      // calculating brand in case of section comprtiotion brand type exists

      let sectionComprtitorBrandType =
        section_metadata?.comp_brand_type === false ||
        section_metadata?.comp_brand_type === true
          ? section_metadata?.comp_brand_type
          : null;
      let sectionComprtitorBrandTypeExists =
        sectionComprtitorBrandType === false ||
        sectionComprtitorBrandType === true;
      let updatedComBrandList = [];
      // if (
      //   !(Section_is_locked && section_brands?.columns?.length) &&
      //   sectionComprtitorBrandTypeExists
      // ) {
      if (shareBrands) {
        let comBrand = defaultBrands?.brands?.columns?.[0]?.competitor
          ? defaultBrands?.brands?.columns?.[0]
          : defaultBrands?.brands?.[0]?.competitor
          ? defaultBrands?.brands?.[0]
          : defaultBrands?.brands?.competitor
          ? defaultBrands?.brands
          : null;
        let comBrandExists = comBrand?.competitor
          ? true
          : defaultBrands
          ? defaultBrands?.selected_brand_ids?.length &&
            defaultBrands?.selected_comp_brand_ids?.length > 0
          : null;
        if (comBrandExists) {
          if (comBrand) {
            if (sectionComprtitorBrandType === false) {
              updatedComBrandList.push({
                brand_id: comBrand?.name,
                brand_name: comBrand?.brand_name,
                brand_friendly_name: comBrand?.brand_friendly_name,
              });
            } else {
              comBrand?.competitorList?.forEach((competitorBrand) => {
                updatedComBrandList.push(competitorBrand);
              });
            }
          } else {
            if (sectionComprtitorBrandType === false) {
              let parentB = defaultBrands?.selected_brand_ids?.[0];
              updatedComBrandList.push({
                brand_id: parentB?.brand_id,
                brand_name: parentB?.brand_name,
                brand_friendly_name: parentB?.brand_friendly_name,
              });
            } else {
              defaultBrands?.selected_comp_brand_ids?.forEach(
                (competitorBrand) => {
                  updatedComBrandList.push(competitorBrand);
                }
              );
            }
          }
        } else {
          sectionComprtitorBrandTypeExists = false;
        }
      } else {
        let comBrand = global_brands?.columns?.[0]?.competitor
          ? global_brands?.columns?.[0]
          : global_brands?.[0]?.competitor
          ? global_brands?.[0]
          : global_brands?.competitor
          ? global_brands
          : null;
        if (comBrand?.competitor) {
          if (sectionComprtitorBrandType === false) {
            updatedComBrandList.push({
              brand_id: comBrand?.name,
              brand_name: comBrand?.brand_name,
              brand_friendly_name: comBrand?.brand_friendly_name,
            });
          } else {
            comBrand?.competitorList?.forEach((competitorBrand) => {
              updatedComBrandList.push(competitorBrand);
            });
          }
        } else {
          sectionComprtitorBrandTypeExists = false;
        }
      }
      // }
      // here calculating the public_engagement_only for the deepdive
      let public_engagement_only =
        pathName === "CommandCenter"?.toLowerCase() || isDeepDiveDashboardView
          ? false // for now static false sending for command center
          : shareBrands
          ? shareTemplateData?.template_type === "competition"
            ? shareTemplateData?.public_engagement_only || false
            : false
          : panes?.[index]?.template_type === "competition"
          ? panes?.[index]?.public_engagement_only || false
          : false;
      let graphObject = {
        account_list: metadata?.payload?.account_list
          ? metadata?.payload?.account_list
          : null,
        start_date: metadata?.payload?.start_date
          ? metadata?.payload?.start_date
          : widgets_is_locked
          ? widget_metadata?.start_date
            ? widget_metadata?.start_date
            : global_duration?.from
            ? global_duration?.from
            : defaultDuration?.from
          : Section_is_locked
          ? section_metadata?.start_date
            ? section_metadata?.start_date
            : global_duration?.from
            ? global_duration?.from
            : defaultDuration?.from
          : global_duration?.from
          ? global_duration?.from
          : defaultDuration?.from,
        end_date: metadata?.payload?.end_date
          ? metadata?.payload?.end_date
          : widgets_is_locked
          ? widget_metadata?.end_date
            ? widget_metadata?.end_date
            : global_duration?.to
            ? global_duration?.to
            : defaultDuration?.to
          : Section_is_locked
          ? section_metadata?.end_date
            ? section_metadata?.end_date
            : global_duration?.to
            ? global_duration?.to
            : defaultDuration?.to
          : global_duration?.to
          ? global_duration?.to
          : defaultDuration?.to,
        brands: shareBrands
          ? widget_metadata?.is_locked
            ? widget_brands?.columns
              ? widget_brands?.columns
              : section_metadata?.is_locked
              ? section_brands?.columns
                ? section_brands?.columns
                : widget_metadata?.duplicate_for_brands
                ? widget_metadata?.com_brand_ids
                : sectionComprtitorBrandTypeExists
                ? updatedComBrandList
                : defaultBrands
              : widget_metadata?.duplicate_for_brands
              ? widget_metadata?.com_brand_ids
              : sectionComprtitorBrandTypeExists
              ? updatedComBrandList
              : defaultBrands
            : section_metadata?.is_locked
            ? section_brands?.columns
              ? section_brands?.columns
              : widget_metadata?.duplicate_for_brands
              ? widget_metadata?.com_brand_ids
              : sectionComprtitorBrandTypeExists
              ? updatedComBrandList
              : defaultBrands
            : widget_metadata?.duplicate_for_brands
            ? widget_metadata?.com_brand_ids
            : sectionComprtitorBrandTypeExists
            ? updatedComBrandList
            : defaultBrands
          : widgets_is_locked
          ? widget_metadata?.brand_ids || widget_metadata?.brand_groups
            ? widget_brands?.columns
            : Section_is_locked
            ? section_metadata?.brand_ids || section_metadata?.brand_groups
              ? section_brands?.columns
              : widget_metadata?.duplicate_for_brands
              ? widget_metadata?.com_brand_ids
              : sectionComprtitorBrandTypeExists
              ? updatedComBrandList
              : global_brands
              ? global_brands
              : brandlogicalgroup?.length > 0
              ? brandlogicalgroup
              : brands
            : widget_metadata?.duplicate_for_brands
            ? widget_metadata?.com_brand_ids
            : sectionComprtitorBrandTypeExists
            ? updatedComBrandList
            : global_brands
            ? global_brands
            : brandlogicalgroup?.length > 0
            ? brandlogicalgroup
            : brands
          : Section_is_locked
          ? section_metadata?.brand_ids || section_metadata?.brand_groups
            ? section_brands?.columns
            : widget_metadata?.duplicate_for_brands
            ? widget_metadata?.com_brand_ids
            : sectionComprtitorBrandTypeExists
            ? updatedComBrandList
            : global_brands
            ? global_brands
            : brandlogicalgroup?.length > 0
            ? brandlogicalgroup
            : brands
          : widget_metadata?.duplicate_for_brands
          ? widget_metadata?.com_brand_ids
          : sectionComprtitorBrandTypeExists
          ? updatedComBrandList
          : global_brands
          ? global_brands
          : brandlogicalgroup?.length > 0
          ? brandlogicalgroup
          : brands,
        // isBrandModified:
        //   !shareBrands &&
        //   (widgets_is_locked || Section_is_locked) &&
        //   (section_metadata?.brand_ids ||
        //     section_metadata?.brand_groups ||
        //     widget_metadata?.brand_ids ||
        //     widget_metadata?.brand_groups)
        //     ? true
        //     : global_brands
        //     ? true
        //     : false,
        filters: filter ? filter : null,
        shareCategory: shareCategory,
        filter_by: widget_metadata?.payload?.filter_by,
        filter_dropdown: widget_metadata?.payload?.filter_dropdown,
        screen: pathName === "CommandCenter"?.toLowerCase() ? screen : null,
        isTicketBased: widget_ids?.includes("6.1"),
        isWorkFlowBased: widget_ids?.includes("8.1"),
        isSurveyCardBased: false,
        public_engagement_only: public_engagement_only ? true : false,
      };
      graphObject.isBrandModified =
        !shareBrands &&
        (global_brands ||
          (widgets_is_locked &&
            (widget_brands?.columns
              ? widget_brands?.columns?.length
              : widget_brands?.length)) ||
          (Section_is_locked &&
            (section_brands?.columns
              ? section_brands?.columns?.length
              : section_brands?.length)) ||
          widget_metadata?.duplicate_for_brands)
          ? true
          : false;

      // to add selected widget of deep dive in screen
      if (pathName === "CommandCenter"?.toLowerCase()) {
        dispatch(
          setSelectedDeepdiveWidgetInScreen(section_index, widget_index)
        );
      } else if (shareBrands) {
        // To add selected widget of deep dive of share dashboard
        dispatch(
          setShareSelectedDeepdiveWidget({
            section_index: section_index,
            widget_index: widget_index,
          })
        );
      } else {
        dispatch(
          setSelectedDeepdiveWidget(section_index, widget_index, panes, index)
        );
      }
      let deepDiveInfo = columnObject?.column_details?.deep_dive_info;
      if (
        deepDiveInfo?.template_id &&
        Array.isArray(deepDiveInfo?.template_id)
      ) {
        let templateId = deepDiveInfo?.template_id?.[0];
        graphObject.deepdive_on = {
          x_axis: {
            attribute: columnObject?.column_details?.attribute,
            value: rowObject[columnObject?.title],
            trace_name: columnObject?.title || columnObject?.trace_name,
          },
          // currently we are handled only for x-axis that's why others passing as null
          y_series: metadata?.y_series && false ? metadata?.y_series : null,
          y_axis: metadata?.y_axes && false ? metadata?.y_axes : null,
        };
        graphObject.template_id = templateId;

        // if this is second level deepdive so need to pass sub_deep_dive_on key
        // where old deepdive_on object will pass and new one is same as
        if (
          deepdive_object?.deepdive_on ||
          deepdiveDashboardData?.deepdive_on
        ) {
          let newDeepDiveOnObject = graphObject?.deepdive_on;

          let mentionDeepDiveOnObject = deepdive_object?.deepdive_on
            ? { ...deepdive_object?.deepdive_on }
            : null;
          mentionDeepDiveOnObject = mentionDeepDiveOnObject
            ? deepCopy(mentionDeepDiveOnObject)
            : null;

          let deediveDashboardOnObject = deepdiveDashboardData?.deepdive_on
            ? { ...deepdiveDashboardData?.deepdive_on }
            : null;
          deediveDashboardOnObject = deediveDashboardOnObject
            ? deepCopy(deediveDashboardOnObject)
            : null;

          let sub_deep_dive_on = [];
          if (
            deepdive_object?.sub_deep_dive_on &&
            Array.isArray(deepdive_object.sub_deep_dive_on)
          ) {
            sub_deep_dive_on = [
              ...sub_deep_dive_on,
              ...deepdive_object.sub_deep_dive_on,
            ];
          }
          if (
            deepdiveDashboardData?.sub_deep_dive_on &&
            Array.isArray(deepdiveDashboardData.sub_deep_dive_on)
          ) {
            sub_deep_dive_on = [
              ...sub_deep_dive_on,
              ...deepdiveDashboardData.sub_deep_dive_on,
            ];
          }
          if (mentionDeepDiveOnObject) {
            sub_deep_dive_on.push(mentionDeepDiveOnObject);
          }
          if (deediveDashboardOnObject) {
            sub_deep_dive_on.push(deediveDashboardOnObject);
          }
          graphObject.sub_deep_dive_on =
            sub_deep_dive_on &&
            Array.isArray(sub_deep_dive_on) &&
            sub_deep_dive_on?.length > 0
              ? [...sub_deep_dive_on]
              : null;
        }

        // If brands are by default share brand then need to pass here global brands as dashboard format
        // recalculate
        if (shareBrands) {
          if (
            graphObject?.brands &&
            (graphObject?.brands?.selected_brand_ids?.length > 0 ||
              graphObject?.brands?.selected_brand_groups?.length > 0)
          ) {
            if (graphObject?.brands?.brands?.columns?.length > 0) {
              graphObject.brands = graphObject?.brands?.brands;
            } else if (
              (graphObject?.brands?.selected_brand_ids?.length > 0 ||
                graphObject?.brands?.selected_brand_groups?.length > 0) &&
              !(
                graphObject?.brands?.selected_comp_brand_ids &&
                graphObject?.brands?.selected_comp_brand_ids?.length
              )
            ) {
              // to calculate normal single brand and brand groups
              let selectedBrands = getBrands(
                shareBrands?.brand_groups,
                graphObject?.brands?.selected_brand_ids,
                shareBrands?.brand_list,
                graphObject?.brands?.selected_brand_groups
              );
              graphObject.brands = selectedBrands;
            } else if (
              graphObject?.brands?.selected_brand_ids?.length > 0 &&
              graphObject?.brands?.selected_comp_brand_ids &&
              graphObject?.brands?.selected_comp_brand_ids?.length
            ) {
              let parentB = graphObject?.brands?.selected_brand_ids?.[0];

              let selectedCompBrand = {
                attribute: "BrandID",
                type: "varchar",
                columns: [
                  {
                    group: false,
                    name: parentB?.brand_id,
                    brand_name: parentB?.brand_name,
                    brand_friendly_name: parentB?.brand_friendly_name,
                    type: "include",
                    brand_group_name: false,
                    competitor: true,
                    competitorList:
                      graphObject?.brands?.selected_comp_brand_ids,
                  },
                ],
              };
              graphObject.brands = selectedCompBrand;
            }
          }
        }

        if (pathName === "CommandCenter"?.toLowerCase()) {
          // For Command Center, we need to set the deep dive object
          dispatch(setScreenIsDeepDiveDashboard(true));
        } else if (shareBrands) {
          // For Share Dashboard, we need to set the deep dive object
          shareTemplateData &&
            dispatch({
              type: "SET_SHARE_TEMPLATE_DATA",
              payload: {
                ...shareTemplateData,
                isDeepDiveDashboard: true,
              },
            });
        } else {
          dispatch(setIsDeepDiveDashboard(true, index));
        }
        dispatch(setInitialDeepDiveDashboardData(graphObject));
      } else {
        // Here existing old deepdive flow code for deep dive
        graphObject.deepdive_on = {
          x_axis: {
            attribute: "Template ID",
            value: rowObject["Template ID"],
            trace_name: rowObject["Template Name"],
          },
          y_series: metadata?.y_series ? metadata?.y_series : null,
          y_axis: metadata?.y_axes ? metadata?.y_axes : null,
        };
        graphObject.paneIndex = index;
        graphObject.panes = panes;
        graphObject.shareBrands = shareBrands;
        graphObject.shareTemplateData = {
          ...shareTemplateData,
          isDeepDive: true,
          deep_dive: {
            infoBar: null,
            mentions: null,
            wordcloud: [],
            category: [],
            top_users: [],
            influencers: [],
            source_of_post: [],
            locations: [],
          },
        };
        graphObject.tabName = "Mentions";
        if (isDeepDiveDashboardView) {
          dispatch(setIsDeepDiveInDashboardTemplateData(true)); // to indicate second level deepdive is opened
          // if this is second level deepdive so need to pass sub_deep_dive_on key
          // where old deepdive_on object will pass and new one is same as

          if (deepdiveDashboardData?.deepdive_on) {
            let newDeepDiveOnObject = graphObject?.deepdive_on;
            let deediveDashboardOnObject = deepdiveDashboardData?.deepdive_on
              ? { ...deepdiveDashboardData?.deepdive_on }
              : null;
            deediveDashboardOnObject = deediveDashboardOnObject
              ? deepCopy(deediveDashboardOnObject)
              : null;

            let sub_deep_dive_on = [];
            if (
              deepdiveDashboardData?.sub_deep_dive_on &&
              Array.isArray(deepdiveDashboardData.sub_deep_dive_on)
            ) {
              sub_deep_dive_on = [
                ...sub_deep_dive_on,
                ...deepdiveDashboardData.sub_deep_dive_on,
              ];
            }
            if (deediveDashboardOnObject) {
              sub_deep_dive_on.push(deediveDashboardOnObject);
            }
            graphObject.sub_deep_dive_on =
              sub_deep_dive_on &&
              Array.isArray(sub_deep_dive_on) &&
              sub_deep_dive_on?.length > 0
                ? [...sub_deep_dive_on]
                : null;
          }
        }
        !shareBrands &&
          pathName !== "CommandCenter"?.toLowerCase() &&
          dispatch(setisDeepDive(true, panes, index));

        dispatch(
          setIsDetailedInsightVisible({
            value: false,
            tab_id: null,
            name:
              workspace_privileges?.environment === 2 ||
              share_workspace_privileges?.environment === 2
                ? "Word Cloud"
                : "Mentions",
            key:
              workspace_privileges?.environment === 2 ||
              share_workspace_privileges?.environment === 2
                ? "2"
                : "1",
          })
        );

        dispatch(
          setTabClick({
            tabName: "mentions",
            state: true,
          })
        );
        dispatch(setDeepDiveObject(graphObject));
        dispatch(setDeepDiveMentionsObject(graphObject));
        dispatch(setDeepDiveInfluencersObject(graphObject));
        dispatch(setMentionPageData({ data: null, page: 1, limit: 10 }));
        shareTemplateData &&
          dispatch({
            type: "SET_SHARE_TEMPLATE_DATA",
            payload: {
              ...shareTemplateData,
              isDeepDive: true,
              deep_dive: {
                infoBar: null,
                mentions: null,
                wordcloud: [],
                category: [],
                top_users: [],
                influencers: [],
                source_of_post: [],
                locations: [],
              },
            },
          });

        if (pathName === "CommandCenter"?.toLowerCase()) {
          let deep_dive_object = {
            infoBar: null,
            mentions: null,
            wordcloud: [],
            category: [],
            top_users: [],
            influencers: [],
            source_of_post: [],
            locations: [],
          };

          // Enable Deep DiveModal
          dispatch(setScreenIsDeepDive(true, deep_dive_object));
        }

        dispatch(set_WM_DeepDive(true));
        dispatch(setDeepDiveInfoLoader(true));
        // Get Deep Dive Api Call Function
        dispatch(
          getDeepDive(
            authParams,
            graphObject,
            widget_ids,
            query?.get("share_id")
          )
        );
        setLoad(false);
        dispatch(setOptionHighChart(null));
        window.scrollTo(0, 0);
      }
    }
    return;
  }

  // Render deepDive special case
  const renderDeepDiveCell = (params, index, showPreviousDuration) => {
    const val = params?.value;
    const parsedData = parseSpecialString(val);
    let specialData = null;
    if (parsedData) {
      specialData = <div>{renderSpecialContent(parsedData)}</div>;
    }
    if (
      isDeepDiveEnabledForThisColumn(index, params?.colDef?.deep_dive_info) &&
      !showPreviousDuration
    ) {
      const column = {
        title: params?.colDef?.title,
        trace_name: params?.colDef?.trace_name,
        column_details: {
          deep_dive_info: params?.colDef?.deep_dive_info,
          attribute: params?.colDef?.attribute,
        },
      };
      return (
        <div className="deepDive">
          {specialData ? (
            <span
              onClick={() => handleGridDeepdive(params?.row, column)}
              className="deepDiveText"
            >
              {specialData}
            </span>
          ) : (
            <span
              onClick={() => handleGridDeepdive(params?.row, column)}
              className="deepDiveText"
            >
              {typeof val === "object" ? val?.value : val}
            </span>
          )}
          {params?.row?.["GMB Location URL"] &&
            (metadata?.chart_type === "grid" ||
              metadata?.chart?.chart_type === "grid") && (
              <>
                <Tooltip
                  slotProps={{
                    tooltip: {
                      sx: {
                        bgcolor: "#2d3e5c", // background color
                        color: "#fff", // text color
                        fontSize: "14px", // font size
                        padding: "8px 12px", // padding inside tooltip
                        borderRadius: "8px", // rounded corners
                        boxShadow: 3, // elevation
                      },
                    },
                  }}
                  title={params?.row?.["GMB Location URL"]}
                >
                  {params?.row?.["GMB Location URL"] !== "NA" ? (
                    <a
                      href={params?.row?.["GMB Location URL"]}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="ml-2 d-inline-flex align-items-center"
                      style={{ verticalAlign: "middle" }}
                      onClick={(e) => e.stopPropagation()}
                    >
                      <EnvironmentOutlined
                        style={{
                          fontSize: "18px",
                          color: "#1890ff",
                        }}
                      />
                    </a>
                  ) : (
                    <span
                      className="ml-2 d-inline-flex align-items-center"
                      style={{
                        verticalAlign: "middle",
                        cursor: "default",
                      }}
                    >
                      <EnvironmentOutlined
                        style={{ fontSize: "18px", color: "#ccc" }}
                      />
                    </span>
                  )}
                </Tooltip>
              </>
            )}
          {params?.row?.["Location Status"] &&
            (metadata?.chart_type === "grid" ||
              metadata?.chart?.chart_type === "grid") && (
              <Tooltip
                slotProps={{
                  tooltip: {
                    sx: {
                      bgcolor: "#2d3e5c", // background color
                      color: "#fff", // text color
                      fontSize: "14px", // font size
                      padding: "8px 12px", // padding inside tooltip
                      borderRadius: "8px", // rounded corners
                      boxShadow: 3, // elevation
                    },
                  },
                }}
                title={
                  params?.row?.["Location Status"] === "Verified"
                    ? "Verified"
                    : "Unverified"
                }
              >
                <img
                  src={
                    params?.row?.["Location Status"] === "Verified"
                      ? googleVerified
                      : googleUnverified
                  }
                  className="ml-2 d-inline-block"
                  style={{
                    width: "1.5rem",
                    height: "1.5rem",
                    verticalAlign: "middle",
                  }}
                />
              </Tooltip>
            )}
        </div>
      );
    } else {
      return (
        <div className="deepDive">
          {specialData ? (
            <span>{specialData}</span>
          ) : (
            <span>{typeof val === "object" ? val?.value : val}</span>
          )}
          {params?.row?.["GMB Location URL"] &&
            (metadata?.chart_type === "grid" ||
              metadata?.chart?.chart_type === "grid") && (
              <>
                <Tooltip
                  slotProps={{
                    tooltip: {
                      sx: {
                        bgcolor: "#2d3e5c", // background color
                        color: "#fff", // text color
                        fontSize: "14px", // font size
                        padding: "8px 12px", // padding inside tooltip
                        borderRadius: "8px", // rounded corners
                        boxShadow: 3, // elevation
                      },
                    },
                  }}
                  title={params?.row?.["GMB Location URL"]}
                >
                  {params?.row?.["GMB Location URL"] !== "NA" ? (
                    <a
                      href={params?.row?.["GMB Location URL"]}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="ml-2 d-inline-flex align-items-center"
                      style={{ verticalAlign: "middle" }}
                      onClick={(e) => e.stopPropagation()}
                    >
                      <EnvironmentOutlined
                        style={{
                          fontSize: "18px",
                          color: "#1890ff",
                        }}
                      />
                    </a>
                  ) : (
                    <span
                      className="ml-2 d-inline-flex align-items-center"
                      style={{
                        verticalAlign: "middle",
                        cursor: "default",
                      }}
                    >
                      <EnvironmentOutlined
                        style={{ fontSize: "18px", color: "#ccc" }}
                      />
                    </span>
                  )}
                </Tooltip>
              </>
            )}
          {params?.row?.["Location Status"] &&
            (metadata?.chart_type === "grid" ||
              metadata?.chart?.chart_type === "grid") && (
              <Tooltip
                slotProps={{
                  tooltip: {
                    sx: {
                      bgcolor: "#2d3e5c", // background color
                      color: "#fff", // text color
                      fontSize: "14px", // font size
                      padding: "8px 12px", // padding inside tooltip
                      borderRadius: "8px", // rounded corners
                      boxShadow: 3, // elevation
                    },
                  },
                }}
                title={
                  params?.row?.["Location Status"] === "Verified"
                    ? "Verified"
                    : "Unverified"
                }
              >
                <img
                  src={
                    params?.row?.["Location Status"] === "Verified"
                      ? googleVerified
                      : googleUnverified
                  }
                  className="ml-2 d-inline-block"
                  style={{
                    width: "1.5rem",
                    height: "1.5rem",
                    verticalAlign: "middle",
                  }}
                />
              </Tooltip>
            )}
        </div>
      );
    }
  };

  const isValidDate = useCallback((dateStr) => {
    const date = new Date(dateStr);
    return !isNaN(date.getTime());
  }, []);

  useEffect(() => {
    const showPrevComparison =
      props?.metadata?.chart?.chart_settings
        ?.show_previous_duration_comparison ||
      props?.metadata?.chart_settings?.show_previous_duration_comparison;

    const showPreviousDuration =
      props?.metadata?.chart?.chart_settings?.show_previous_duration_data ||
      props?.metadata?.chart_settings?.show_previous_duration_data;

    let column = columns.map((col, index) => {
      return {
        ...col,
        renderHeader: (params) => {
          // Visual Enhancement: Color-coded columns
          const columnColor =
            colors && colors[index] !== "#000000" ? colors[index] : null;
          return (
            <span style={{ color: columnColor }}>
              {params.colDef.headerName}
            </span>
          );
        },
        // modified cells
        renderCell: (params) => {
          let val = params?.value;
          let length = params?.value?.length;
          const rowData = params?.row;
          // 1️⃣ No value → show fallback
          if (val === null || val === undefined) return <span>-</span>;

          // deepdive flow start from here
          if (params?.colDef && params?.colDef?.deep_dive_info) {
            return renderDeepDiveCell(params, index, showPreviousDuration);
          }

          // row span rendering for specified column

          // Visual Enhancement: Special string parsing
          const parsedData = parseSpecialString(val);
          if (parsedData) {
            return <div>{renderSpecialContent(parsedData)}</div>;
          }

          // Visual Enhancement: Rating display
          const ratingValue = renderRating(val);
          if (ratingValue !== val) {
            return <span>{ratingValue}</span>;
          }

          // Visual Enhancement: GMB Location URL
          if (col.field === "gmb_url" || col.field === "GMB Location URL") {
            return <div>{renderGMBLocation(val, rowData)}</div>;
          }
          // Visual Enhancement: Object profile name with GMB URL and Verified icons
          if (
            (col.field === "object_profile_name" ||
              col.field === "emailcontenthtml") &&
            rowData &&
            rowData["GMB Location URL"]
          ) {
            return (
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                }}
              >
                <span>{val}</span>
                {/* GMB Location URL Icon */}
                {rowData["GMB Location URL"] && (
                  <Tooltip
                    slotProps={{
                      tooltip: {
                        sx: {
                          bgcolor: "#2d3e5c", // background color
                          color: "#fff", // text color
                          fontSize: "14px", // font size
                          padding: "8px 12px", // padding inside tooltip
                          borderRadius: "8px", // rounded corners
                          boxShadow: 3, // elevation
                        },
                      },
                    }}
                    title={rowData["GMB Location URL"]}
                  >
                    {rowData["GMB Location URL"] !== "NA" ? (
                      <a
                        href={rowData["GMB Location URL"]}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="ml-2 d-inline-flex align-items-center"
                        style={{ verticalAlign: "middle", marginLeft: "8px" }}
                        onClick={(e) => e.stopPropagation()}
                      >
                        <EnvironmentOutlined
                          style={{ fontSize: "18px", color: "#1890ff" }}
                        />
                      </a>
                    ) : (
                      <span
                        className="ml-2 d-inline-flex align-items-center"
                        style={{
                          verticalAlign: "middle",
                          marginLeft: "8px",
                          cursor: "default",
                        }}
                      >
                        <EnvironmentOutlined
                          style={{ fontSize: "18px", color: "#ccc" }}
                        />
                      </span>
                    )}
                  </Tooltip>
                )}
                {/* Verified Icon */}
                {rowData["Location Status"] && (
                  <Tooltip
                    slotProps={{
                      tooltip: {
                        sx: {
                          bgcolor: "#2d3e5c", // background color
                          color: "#fff", // text color
                          fontSize: "14px", // font size
                          padding: "8px 12px", // padding inside tooltip
                          borderRadius: "8px", // rounded corners
                          boxShadow: 3, // elevation
                        },
                      },
                    }}
                    title={
                      rowData["Location Status"] === "Verified"
                        ? "Verified"
                        : "Unverified"
                    }
                  >
                    <img
                      src={
                        rowData["Location Status"] === "Verified"
                          ? googleVerified
                          : googleUnverified
                      }
                      className="ml-2 d-inline-block"
                      style={{
                        width: "1.5rem",
                        height: "1.5rem",
                        verticalAlign: "middle",
                        marginLeft: "8px",
                      }}
                    />
                  </Tooltip>
                )}
              </div>
            );
          }

          const showValley =
            props?.metadata?.chart?.chart_settings?.show_valley ||
            props?.metadata?.chart_settings?.show_valley;
          const showPeak =
            props?.metadata?.chart?.chart_settings?.show_peak ||
            props?.metadata?.chart_settings?.show_peak;
          // 2️⃣ If comparison disabled → just show raw value

          if (
            showPeak &&
            !showValley &&
            !showPrevComparison &&
            (params?.colDef?.datatype === "int" || typeof val === "number") &&
            rows?.length > 1
          ) {
            if (
              minMax[params?.field] &&
              val === minMax[params?.field].max &&
              minMax[params?.field].maxId === params.row.id
            ) {
              return (
                <Tooltip
                  title={"Max Value"}
                  slotProps={{
                    tooltip: {
                      sx: {
                        bgcolor: "#2d3e5c", // background color
                        color: "#fff", // text color
                        fontSize: "14px", // font size
                        padding: "8px 12px", // padding inside tooltip
                        borderRadius: "8px", // rounded corners
                        boxShadow: 3, // elevation
                      },
                    },
                  }}
                >
                  <span
                    className="textStyle"
                    style={{
                      padding: "10px",
                      backgroundColor: "#185edf1a",
                      cursor: "pointer",
                      color: "#185edf",
                      borderRadius: ".8rem",
                      display: "inline-block",
                      margin: "4px",
                      height: "80%",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                  >
                    {val.toLocaleString("en-US")}
                  </span>
                </Tooltip>
              );
            } else {
              return (
                <span className="textStyle">
                  {typeof val === "object"
                    ? val?.value.toLocaleString("en-US")
                    : val.toLocaleString("en-US")}
                </span>
              );
            }
          } else if (
            showValley &&
            !showPeak &&
            !showPrevComparison &&
            (params?.colDef?.datatype === "int" || typeof val === "number") &&
            rows?.length > 1
          ) {
            if (
              minMax[params?.field] &&
              val === minMax[params?.field].min &&
              minMax[params?.field].minId === params.row.id
            ) {
              return (
                <Tooltip
                  title={"Min Value"} // 👈 Tooltip content
                  slotProps={{
                    tooltip: {
                      sx: {
                        bgcolor: "#2d3e5c", // background color
                        color: "#fff", // text color
                        fontSize: "14px", // font size
                        padding: "8px 12px", // padding inside tooltip
                        borderRadius: "8px", // rounded corners
                        boxShadow: 3, // elevation
                      },
                    },
                  }}
                >
                  <span
                    className="textStyle"
                    style={{
                      padding: "10px",
                      backgroundColor: "#a020f01a",
                      cursor: "pointer",
                      color: "#a020f0",
                      borderRadius: ".8rem",
                      display: "inline-block",
                      margin: "4px",
                      height: "80%",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                  >
                    {val.toLocaleString("en-US")}
                  </span>
                </Tooltip>
              );
            } else {
              return (
                <span className="textStyle">
                  {typeof val === "object"
                    ? val?.value?.toLocaleString("en-US")
                    : val?.toLocaleString("en-US")}
                </span>
              );
            }
          } else if (
            showPeak &&
            showValley &&
            !showPrevComparison &&
            (params?.colDef?.datatype === "int" || typeof val === "number") &&
            rows?.length > 1
          ) {
            if (
              minMax[params?.field] &&
              val === minMax[params?.field].max &&
              minMax[params?.field].maxId === params.row.id
            ) {
              return (
                <Tooltip
                  title={"Max Value"} // 👈 Tooltip content
                  slotProps={{
                    tooltip: {
                      sx: {
                        bgcolor: "#2d3e5c", // background color
                        color: "#fff", // text color
                        fontSize: "14px", // font size
                        padding: "8px 12px", // padding inside tooltip
                        borderRadius: "8px", // rounded corners
                        boxShadow: 3, // elevation
                      },
                    },
                  }}
                >
                  <span
                    className="textStyle"
                    style={{
                      padding: "10px",
                      backgroundColor: "#185edf1a",
                      cursor: "pointer",
                      color: "#185edf",
                      borderRadius: ".8rem",
                      display: "inline-block",
                      margin: "4px",
                      height: "80%",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                  >
                    {typeof val === "object"
                      ? val?.value?.toLocaleString("en-US")
                      : val?.toLocaleString("en-US")}
                  </span>
                </Tooltip>
              );
            } else if (
              minMax[params?.field] &&
              val === minMax[params?.field].min &&
              minMax[params?.field].minId === params.row.id
            ) {
              return (
                <Tooltip
                  title={"Min Value"} // 👈 Tooltip content
                  slotProps={{
                    tooltip: {
                      sx: {
                        bgcolor: "#2d3e5c", // background color
                        color: "#fff", // text color
                        fontSize: "14px", // font size
                        padding: "8px 12px", // padding inside tooltip
                        borderRadius: "8px", // rounded corners
                        boxShadow: 3, // elevation
                      },
                    },
                  }}
                >
                  <span
                    className="textStyle"
                    style={{
                      padding: "10px",
                      backgroundColor: "#a020f01a",
                      cursor: "pointer",
                      color: "#a020f0",
                      borderRadius: ".8rem",
                      display: "inline-block",
                      margin: "4px",
                      margin: "4px",
                      height: "80%",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                  >
                    {typeof val === "object"
                      ? val?.value?.toLocaleString("en-US")
                      : val?.toLocaleString("en-US")}
                  </span>
                </Tooltip>
              );
            } else {
              return (
                <span className="textStyle">
                  {typeof val === "object"
                    ? val?.value?.toLocaleString("en-US")
                    : val?.toLocaleString("en-US")}
                </span>
              );
            }
          }
          // 3️⃣ Handle object with { value, percent_change }
          if (
            typeof val === "object" &&
            val?.value !== null &&
            showPrevComparison
          ) {
            const { value, percent_change } = val;

            // If no percent_change → show only value
            if (!percent_change && percent_change !== 0) {
              return <span className="textStyle">{value}</span>;
            }

            const isPositive = percent_change > 0;
            const color = isPositive ? "#1c9f00" : "red";
            const rotation = isPositive ? 0 : 180;

            return (
              <div
                style={{
                  display: "flex",
                  flexWrap: "wrap",
                  alignItems: "center",
                  whiteSpace: "normal",
                  lineHeight: "1.4rem",
                  padding: "8px 0px",
                  margin: 0,
                }}
              >
                <span className="textStyle">{value}</span>
                {percent_change !== 0 && (
                  <div style={{ display: "flex", alignItems: "center" }}>
                    <CaretUpOutlined
                      style={{
                        fontSize: "1rem",
                        color,
                        transform: `rotate(${rotation}deg)`,
                        borderRadius: "50%",
                        padding: "2px",
                      }}
                    />
                    <span style={{ fontSize: "1rem", color, fontWeight: 700 }}>
                      {percent_change}%
                    </span>
                  </div>
                )}
              </div>
            );
          }

          if (length >= 50) {
            return (
              <Tooltip
                slotProps={{
                  tooltip: {
                    sx: {
                      bgcolor: "#2d3e5c", // background color
                      color: "#fff", // text color
                      fontSize: "14px", // font size
                      padding: "8px 12px", // padding inside tooltip
                      borderRadius: "8px", // rounded corners
                      boxShadow: 3, // elevation
                    },
                  },
                }}
                title={val?.toLocaleString("en-US")}
              >
                <span
                  className="textStyle"
                  style={{
                    overflow: "hidden",
                    whiteSpace: "nowrap",
                    textOverflow: "ellipsis",
                  }}
                >
                  {typeof val === "object"
                    ? val?.value?.toLocaleString("en-US")
                    : val?.toLocaleString("en-US")}
                </span>
              </Tooltip>
            );
          }
          // 4️⃣ Non-object → render directly
          return (
            <span
              style={{
                justifyContent:
                  params?.field === rowSpanOn ? params?.colDef?.align : null,
              }}
              className={
                params?.field === rowSpanOn
                  ? "my-custom-span-class"
                  : "textStyle"
              }
            >
              {typeof val === "object"
                ? val?.value?.toLocaleString("en-US")
                : val?.toLocaleString("en-US")}
            </span>
          );
        },
      };
    });

    // add sorting for Date format
    column = column.map((col) => {
      if (col?.datatype === "datetime") {
        return {
          ...col,
          sortComparator: (v1, v2, param1, param2) => {
            const val1 = param1?.value ? param1?.value : param1?.value?.value;
            const val2 = param2?.value ? param2?.value : param2?.value?.value;

            if (val1 === "NA" && val2 === "NA") {
              return 0;
            } else if (val1 === "NA" && isValidDate(val2)) {
              return 0 - new Date(val2).getTime();
            } else if (val2 === "NA" && isValidDate(val1)) {
              return new Date(val1).getTime() - 0;
            } else if (isValidDate(val1) && isValidDate(val2)) {
              return new Date(val1).getTime() - new Date(val2).getTime();
            }
            return val1.localeCompare(val2);
          },
        };
      }
      return col;
    });
    // sorting for previous duration comparison
    if (showPrevComparison) {
      column = column.map((col) => {
        return {
          ...col,
          sortComparator: (v1, v2, param1, param2) => {
            const val1 = param1?.value?.value
              ? param1?.value?.value
              : param1?.value;
            const val2 = param2?.value?.value
              ? param2?.value?.value
              : param2?.value;
            if (!isNaN(val1) && !isNaN(val2)) return val1 - val2;

            if (typeof val1 === "string" && typeof val2 === "string") {
              return val1
                ?.split("|$|")?.[0]
                .trim()
                .localeCompare(val2?.split("|$|")?.[0].trim());
            }
          },
        };
      }); // custom comparison
    }

    if (showPreviousDuration) {
      column = column.map((col) => {
        if (col?.field !== col?.parent) {
          return {
            ...col,
            sortComparator: (v1, v2, param1, param2) => {
              if (param1.value === "NA" && param2.value === "NA") {
                return 0;
              } else if (param1.value === "NA") {
                return 0 - param2.value;
              } else if (param2.value === "NA") {
                return param1.value - 0;
              }
              return param1.value - param2.value;
            },
          };
        }
        return col;
      });
    }
    setModifiedColumns(column);
  }, [columns, props, minMax, colors]);

  const resetSorting = useCallback(() => {
    setRows(getDataSource(getUpdatedDataSource(dataSource)));
    return [];
  }, [dataSource]);

  return (
    <DataGrid
      autoHeight={rows?.length <= 5 ? true : false}
      loading={loading}
      rowSpanning={handleRowSpanning}
      columns={modiFiedColumns}
      columnGroupingModel={columnGroupingModel}
      onColumnWidthChange={handleColumnResize}
      rows={rows}
      ref={gridRef}
      getRowHeight={() => (handleRowSpanning ? 46 : "auto")}
      disableVirtualization
      density="compact"
      showCellVerticalBorder
      showColumnVerticalBorder
      disableRowSelectionOnClick
      disableColumnMenu
      columnHeaderHeight={64}
      sortingMode="client"
      sortModel={[...gridConfigSort?.sortModel]}
      sortingOrder={["asc", "desc"]}
      disableColumnSorting={handleRowSpanning ? true : false}
      onSortModelChange={(newModel) => {
        if (!newModel.length) return;
        setGridConfigSort((prev) => {
          const { sortModel } = prev;
          let sort = sortModel?.[0];
          if (
            sort &&
            sort.field === newModel[0].field &&
            sort?.sort === "desc" &&
            newModel[0].sort === "asc"
          ) {
            return {
              sortModel: resetSorting(),
            };
          }
          return {
            sortModel: newModel,
          };
        });
      }}
      hideFooterPagination={pagination.pagination}
      paginationModel={paginationModel}
      pageSizeOptions={pagination.pageSizeOptions}
      slots={{
        pagination: () => (
          <CustomPagination
            setPaginationModel={setPaginationModel}
            paginationModel={paginationModel}
            rowCount={rows.length}
          />
        ),
      }}
      slotProps={{
        tooltip: {
          componentsProps: {
            tooltip: {
              sx: {
                backgroundColor: "#3b5175",
                color: "#fff",
                fontSize: "1.2rem",
                fontFamily: "Roboto, sans-serif",
                padding: "6px 12px",
                borderRadius: "6px",
              },
            },
          },
        },
        basePopper: {
          sx: {
            color: "#3b5175",
            fontSize: "1.4rem",
            fontWeight: 700,
            minWidth: 200,
            fontFamily: "sans-serif",
            /* Hide scrollbar visually but keep scroll functional */
            overflowX: "auto !important",
            scrollbarWidth: "none !important", // Firefox
            "&::-webkit-scrollbar": {
              display: "none !important", // Chrome, Safari, Edge
            },
            "& .MuiPaper-root": {
              color: "#3b5175",
              fontSize: "1.4rem",
              fontWeight: 700,
              minWidth: "200px",
              fontFamily: "sans-serif",
              display: handleRowSpanning || preview ? "none" : "block",
            },
            "& .MuiList-root": {
              minWidth: "200px !important",
            },
            "& .MuiTablePagination-root": {
              color: "#3b5175",
              fontSize: "1.4rem",
              fontWeight: 700,
              minWidth: 200,
              fontFamily: "sans-serif",
            },
            "& .MuiTablePagination-input": {
              color: "#3b5175",
              fontSize: "1.4rem",
              fontWeight: 700,
              minWidth: 200,
              fontFamily: "sans-serif",
            },
            "& .MuiMenuItem-root:nth-last-child(-n+5)": {
              display: "none",
            },
            "& .MuiDivider-root": {
              display: "none",
            },
            "& .MuiListItemText-root .MuiListItemText-primary": {
              color: "#3b5175",
              fontSize: "1.4rem",
              fontWeight: 700,
              minWidth: 200,
              fontFamily: "sans-serif",
              overflowX: "none !important",
            },
          },
        },
      }}
      sx={(theme) => ({
        border: "none",
        borderRadius: "0",
        fontSize: "1.4rem",
        fontFamily: "Roboto,sans-serif",
        fontWeight: 700,
        color: "#3b5175",
        backgroundColor: "#ffffff",
        fontFamily: "sans-serif",
        width: "100%",
        height: `${gridHeight}px`,
        padding: "15px",
        "& .MuiDataGrid-columnHeader": {
          backgroundColor: "#f1f3f6 !important",
          border: "1px solid #dfe3e9",
          borderTop: "none !important",
          borderLeft: "none !important",
          whiteSpace:
            isdownload || isPPTModalOpen
              ? "nowrap !important"
              : "normal !important",
          overflow:
            isdownload || isPPTModalOpen
              ? "hidden !important"
              : "visible !important",
          textOverflow:
            isdownload || isPPTModalOpen
              ? "ellipsis !important"
              : "unset !important",
          wordWrap:
            isdownload || isPPTModalOpen
              ? "normal !important"
              : "break-word !important",
          "&": {
            "--DataGrid-t-color-interactive-focus": "none !important", // force scrollbar size everywhere
          },
        },
        "& .MuiDataGrid-iconButtonContainer": {
          position: "relative",
          left: "4px",
        },
        "& .MuiDataGrid-columnHeaderTitleContainerContent": {
          whiteSpace:
            isdownload || isPPTModalOpen
              ? "nowrap !important"
              : "normal !important",
          overflow:
            isdownload || isPPTModalOpen
              ? "hidden !important"
              : "visible !important",
          textOverflow:
            isdownload || isPPTModalOpen
              ? "ellipsis !important"
              : "unset !important",
          wordWrap:
            isdownload || isPPTModalOpen
              ? "normal !important"
              : "break-word !important",
          display:
            isdownload || isPPTModalOpen
              ? "block !important"
              : "flex !important",
        },
        "& .MuiDataGrid-filler": {
          height: "0px !important",
          minHeight: "0px !important",
          border: "0px solid !important",
        },
        "& .MuiDataGrid-footerContainer": {
          display:
            pagination.pagination || isdownload || isPPTModalOpen
              ? "none !important"
              : "flex !important",
        },

        "& .MuiTooltip-tooltip": {
          backgroundColor: "#3b5175",
          color: "#fff",
          fontSize: "1.2rem",
          fontFamily: "Roboto, sans-serif",
          padding: "6px 12px",
          borderRadius: "6px",
        },
        "& .MuiDataGrid-cell": {
          fontSize: "1.4rem !important",
          fontFamily: "Roboto, sans-serif",
          fontWeight: "700 !important",
          color: "#3b5175",
          whiteSpace: "normal",
          wordWrap: "break-word",
          display: "flex",
          alignItems: "center",
          minHeight: "42px",
          border: handleRowSpanning ? null : "none !important",
          "&": {
            "--DataGrid-t-color-interactive-focus": "none !important", // force scrollbar size everywhere
          },
        },

        "& .MuiDataGrid-row:nth-of-type(odd)": {
          backgroundColor: handleRowSpanning ? "null" : "#f7f8fa",
        },

        "& .MuiDataGrid-row:nth-of-type(odd):hover": {
          backgroundColor: handleRowSpanning
            ? "white !important"
            : "#e8ecf7 !important",
        },

        "& .MuiDataGrid-row:nth-of-type(even):hover": {
          backgroundColor: handleRowSpanning
            ? "white !important"
            : "#e8ecf7 !important",
        },
        "& .MuiTablePagination-root": {
          fontSize: "1.4rem",
          fontFamily: "Roboto,sans-serif",
          fontWeight: 700,
          color: "#3b5175",
          minHeight: "52px",
          display: "flex",
          justifyContent: "end",
          alignItems: "center",
        },
        "& .MuiTablePagination-root .MuiTablePagination-selectLabel": {
          fontSize: "1.4rem",
          fontFamily: "Roboto,sans-serif",
          fontWeight: 700,
          color: "#3b5175",
          marginBottom: 0,
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        },
        "& .MuiTablePagination-displayedRows": {
          fontSize: "1.4rem",
          fontFamily: "Roboto,sans-serif",
          fontWeight: 700,
          color: "#3b5175",
          marginBottom: 0,
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        },
        "& .MuiDataGrid-selectedRowCount": {
          fontSize: "1.4rem",
          fontFamily: "Roboto,sans-serif",
          fontWeight: 700,
          color: "#3b5175",
          marginBottom: 0,
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        },
        "& .MuiSelect-select": {
          fontWeight: 700,
        },
        "& .MuiTablePagination-root": {
          display: props?.preview ? "none" : "block",
          fontSize: "1.4rem",
          fontFamily: "Roboto,sans-serif",
          fontWeight: 700,
          color: "#3b5175",
        },

        "&": {
          "--DataGrid-scrollbarSize": "10px !important", // force scrollbar size everywhere
        },
        "& .MuiDataGrid-scrollbar--horizontal": {
          height: "10px !important", // fix horizontal scrollbar height
          backgroundColor: "#f1f1f1", // optional background
        },
        "& .MuiDataGrid-scrollbar--vertical": {
          display: gridHeight ? "block" : "none !important",
        },
        "& .MuiDataGrid-scrollbar--horizontal .MuiDataGrid-scrollbarContent": {
          height: "10px !important", // match content
        },
        "& .MuiDataGrid-scrollbar--horizontal::-webkit-scrollbar": {
          height: "10px", // webkit-specific (Chrome, Edge, Safari)
        },
      })}
    />
  );
}

export default React.memo(AdvGrid, isEqual);
